import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('userData');
    const devicesData = localStorage.getItem('devicesData');
    
    if (token && userData) {
      try {
        setUser({ token, ...JSON.parse(userData) });
        if (devicesData) {
          setDevices(JSON.parse(devicesData));
        }
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        // Clear corrupted data
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        localStorage.removeItem('devicesData');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Login failed');
      }

      const { user: userData, devices: devicesData, token } = result.data;
      
      // Store in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('userData', JSON.stringify(userData));
      localStorage.setItem('devicesData', JSON.stringify(devicesData || []));
      
      // Update state
      setUser({ token, ...userData });
      setDevices(devicesData || []);
      
      return result;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('devicesData');
    setUser(null);
    setDevices([]);
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      devices, 
      login, 
      logout, 
      loading,
      setDevices // Allow updating devices from other components
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);